import { BaseResponseCode } from 'shared/entities/network';
import { TranslationString } from 'shared/entities/localization';
import {
  EmailDomainPolicyError,
  mapEmailDomainPolicyErrorToMessage
} from 'shared/entities/emailDomainPolicy';

export enum ManagerAddingErrorCode {
  managerNotFound = 'manager_not_found'
}

export type CabinetManagerAddingErrorCode =
  | ManagerAddingErrorCode
  | BaseResponseCode.conflict
  | EmailDomainPolicyError.REGISTRATION_EMAIL_DOMAIN_NOT_ALLOWED;

export const mapManagerAddingErrorCodeToMessage = (
  code: CabinetManagerAddingErrorCode
): TranslationString => {
  if (code === EmailDomainPolicyError.REGISTRATION_EMAIL_DOMAIN_NOT_ALLOWED) {
    return mapEmailDomainPolicyErrorToMessage(code);
  }

  return (t) =>
    t(`manager.addingCabinetManagerErrors.${code}`, {
      ns: 'entities'
    });
};
